import {
  AppMultiAsync,
  AppRemixIcon,
  AppSingleAsync,
} from '@/layout/AppComponents';
import errorHandler from '@/layout/components/error/ErrorHandler';
import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { axiosPath } from '../../../../routing/helpers/router';
import useIsMounted from '../../hooks/useIsMounted';

export default function LocationSelect({
  value,
  onChange,
  title,
  parentLocationID = 1,
  isMulti = true,
  error,
}) {
  const dispatch = useDispatch();
  const isMounted = useIsMounted();

  const loadAsyncLocations = useCallback(
    async (payload) =>
      axios
        .post(axiosPath('api_r_user_global_select_location'), {
          payload,
          parentLocationID,
        })
        .then(({ data }) => {
          if (isMounted.current) {
            return data;
          }
        })
        .catch((e) => dispatch(errorHandler(e))),
    [parentLocationID]
  );

  if (isMulti === true) {
    return (
      <>
        <AppMultiAsync
          title={title || 'Ubicación general'}
          icon={<AppRemixIcon icon="map-pin-2" />}
          asyncFunction={loadAsyncLocations}
          value={value}
          onChange={onChange}
          error={error}
        />
      </>
    );
  }

  return (
    <AppSingleAsync
      title={title || 'Ubicación general'}
      icon={<AppRemixIcon icon="map-pin-2" />}
      asyncFunction={loadAsyncLocations}
      value={value}
      onChange={onChange}
      error={error}
    />
  );
}
